import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../../components/ConfirmationModal';
import { userLabel } from './appropriationUtils';

const AppropriationAlert = ({
  activeAppropriation,
  appropriations,
  currentUser,
  onAppropriate,
  loading,
  entityLabel,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleConfirmAppropriate = () => {
    setShowConfirmModal(false);
    onAppropriate();
  };

  const appropriateButton = (
    <button
      type="button"
      className="btn btn-primary mt-1"
      onClick={() => setShowConfirmModal(true)}
      disabled={loading}
    >
      {loading ? <FontAwesomeIcon icon="spinner" spin /> : 'Apropriar'}
    </button>
  );

  if (!activeAppropriation) {
    const hadPreviousAppropriation = appropriations.length > 0;
    return (
      <>
        <div className="alert alert-warning" role="alert">
          <span className="d-block">
            <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
            {hadPreviousAppropriation
              ? `Esta ${entityLabel} não tem apropriação ativa. Clique para se apropriar e continuar a revisão.`
              : `Esta ${entityLabel} ainda não foi apropriada. Clique para se apropriar e iniciar a revisão.`}
          </span>
          {appropriateButton}
        </div>
        <Modal
          visible={showConfirmModal}
          title="Confirmar Apropriação"
          onCancel={() => setShowConfirmModal(false)}
          onConfirm={handleConfirmAppropriate}
          cancelText="Cancelar"
          confirmText="Confirmar"
          loading={loading}
        >
          <p>
            Tem certeza que deseja se apropriar desta {entityLabel}? Você poderá
            iniciar a revisão dos documentos após a apropriação.
          </p>
        </Modal>
      </>
    );
  }

  if (activeAppropriation.user.id !== (currentUser && currentUser.id)) {
    return (
      <>
        <div className="alert alert-warning" role="alert">
          <span className="d-block">
            <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
            Esta {entityLabel} está apropriada por{' '}
            <strong>{userLabel(activeAppropriation.user)}</strong> desde{' '}
            {activeAppropriation.start_date}. Clique para se apropriar.
          </span>
          {appropriateButton}
        </div>
        <Modal
          visible={showConfirmModal}
          title="Confirmar Apropriação"
          onCancel={() => setShowConfirmModal(false)}
          onConfirm={handleConfirmAppropriate}
          cancelText="Cancelar"
          confirmText="Confirmar"
          loading={loading}
        >
          <p>
            Esta {entityLabel} está atualmente apropriada por{' '}
            <strong>{userLabel(activeAppropriation.user)}</strong>. Tem certeza que
            deseja se apropriar? A apropriação anterior será encerrada
            automaticamente.
          </p>
        </Modal>
      </>
    );
  }

  return (
    <div className="alert alert-info" role="alert">
      <FontAwesomeIcon icon="info-circle" className="mr-2" />
      Você está apropriado desta {entityLabel} desde{' '}
      <strong>{activeAppropriation.start_date}</strong>.
    </div>
  );
};

AppropriationAlert.propTypes = {
  activeAppropriation: PropTypes.shape({
    id: PropTypes.number,
    user: PropTypes.shape({
      id: PropTypes.number,
      username: PropTypes.string,
      last_name: PropTypes.string,
    }),
    start_date: PropTypes.string,
  }),
  appropriations: PropTypes.arrayOf(PropTypes.object),
  currentUser: PropTypes.shape({
    id: PropTypes.number,
  }),
  onAppropriate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  entityLabel: PropTypes.string,
};

AppropriationAlert.defaultProps = {
  activeAppropriation: null,
  appropriations: [],
  currentUser: null,
  loading: false,
  entityLabel: 'matrícula',
};

export default AppropriationAlert;
